import { render } from "./radar.vue?vue&type=template&id=185cca76&scoped=true&ts=true"
import script from "./radar.vue?vue&type=script&lang=ts"
export * from "./radar.vue?vue&type=script&lang=ts"

import "./radar.vue?vue&type=style&index=0&id=185cca76&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185cca76"]])

export default __exports__